<template>
	<BaseCard
		:is-editable="!isProcessFinished && isEditAllowed"
		:title="title"
		@clickEdit="$router.push({ name: editRoute, params: { id: $route.params.processId || $route.params.id } })"
		:is-toggle-open="isToggleOpen"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
	>
		<template #icons>
			<slot name="icons" />
		</template>
		<template #icons v-if="showWarningDamageAssessor">
			<div class="flex items-center">
				<font-awesome-icon icon="exclamation-triangle" class="text-red-700" />
			</div>
		</template>
		<div v-if="damageAssessorCompany">
			<BaseCardRow :value="damageAssessorCompany.name" :missing-label="$t('company')"></BaseCardRow>
			<BaseCardRow v-if="street != null" :value="street" :missing-label="$t('street')" />
			<BaseCardRow v-else :value="damageAssessorCompany.poBox" :missing-label="$t('po_box')" />
			<BaseCardRow :value="city" :missing-label="$t('city')" />
			<div v-if="damageAssessor" class="mt-6">
				<BaseCardRow :value="damageAssessorName" :missing-label="$t('assigned_damage_assessor')"></BaseCardRow>
				<BaseCardRow :value="damageAssessorPhone" :missing-label="$t('phone')"></BaseCardRow>
				<BaseCardRow :value="damageAssessor.email" :missing-label="$t('e_mail')"></BaseCardRow>
			</div>
		</div>
		<div v-else-if="damageAssessor && damageAssessor.system_assessor === false">
			<BaseCardRow
				v-if="damageAssessor.organisation"
				:value="damageAssessor.organisation"
				:missing-label="$t('company_organisation_assessor_office')"
			></BaseCardRow>
			<BaseCardRow :value="damageAssessorName" :missing-label="$t('assigned_damage_assessor')"></BaseCardRow>
			<BaseCardRow :value="damageAssessorPhone" :missing-label="$t('phone')"></BaseCardRow>
			<BaseCardRow :value="damageAssessor.email" :missing-label="$t('e_mail')"></BaseCardRow>
		</div>

		<div class="font-bold" v-else>
			{{ getMissingValue }}
		</div>
	</BaseCard>
</template>
<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';
import { concatArray } from '@/plugins/Utils';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'DamageAssessorCard',
	components: { BaseCard, BaseCardRow },
	mixins: [Authentication],
	props: {
		damageAssessor: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		damageAssessorCompany: { required: true },
		isProcessFinished: {},
		title: { required: true },
		isEditAllowed: { type: Boolean, default: true },
		editRoute: { type: String },
		missingValue: {},
		isToggleOpen: { type: Boolean, default: true },
	},
	computed: {
		getMissingValue() {
			return this.missingValue || this.title + ' ' + this.$t('not_stored');
		},
		damageAssessorName() {
			return concatArray([this.damageAssessor?.firstName, this.damageAssessor?.lastName]);
		},
		damageAssessorPhone() {
			return this.damageAssessor?.cellNumber || this.damageAssessor?.phoneNumber;
		},
		street: function() {
			if (this.damageAssessorCompany.street === undefined) {
				return null;
			}
			return concatArray([this.damageAssessorCompany.street, this.damageAssessorCompany.houseNumber]);
		},
		city() {
			return concatArray([this.damageAssessorCompany.city.zipCode, this.damageAssessorCompany.city.name]);
		},
		showWarningDamageAssessor() {
			return this.isUserAllowedInLevel2 && Object.keys(this.damageAssessor).length === 0;
		},
	},
	methods: {
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
	},
};
</script>
